import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import {
  useRecoilCallback,
  useRecoilValue,
  useRecoilValue_TRANSITION_SUPPORT_UNSTABLE,
  useSetRecoilState,
} from "recoil";
import AutocompleteSkeleton from "src/shared/components/skeletons/AutocompleteSkeleton";
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi";

import AutocompleteServicio from "./components/autocompletes/AutocompleteServicio";
import AutocompleteProcedimiento from "./components/autocompletes/AutocompleteProcedimiento";
import {
  tipoExamenState,
  tipoExamenesFetchState,
  examenState,
  examenesFetchState,
  ExamenByTipoExamenState,
  sucursalesState,
  sucursalesProcedimientoFetchState,
  sucursalesProcedimientoState,
} from "./components/autocompletes/state/atoms";
import {
  serviciosState,
  serviciosFetchState,
  procedimientosState,
} from "./components/autocompletes/state/atoms";
import {
  filterSearchSelectedState,
  isChangeFormSearchState,
} from "./state/atoms";

import ProcedimientoService from "../services/agenda/procedimientos";
import AutocompletePrevision from "./components/autocompletes/AutocompletePrevision";
import AutocompleteSucursales from "./components/autocompletes/AutocompleteSucursales";
import { userState } from "src/store/user/userState";
import { InputRut } from "src/shared/components/forms/InputRut";
import AutocompleteSucursalesProcedimiento from "./components/autocompletes/AutocompleteSucursalesProcedimiento";
import getConfig from "src/config/appConfig";

const FormSearchProcedimiento = ({
  size = "small",
  md = 12,
  styles = {},
  buttonSearch = null,
}) => {
  const { catchErrorApi } = useCatchErrorApi();
  const setIsChangeFormSearch = useSetRecoilState(isChangeFormSearchState);
  const filterSearchSelected = useRecoilValue(filterSearchSelectedState);
  const setSucursales = useSetRecoilState(sucursalesProcedimientoState);

  const setServicio = useSetRecoilState(serviciosState);
  const setProcedimiento = useSetRecoilState(procedimientosState);

  const [loading, setLoading] = useState(false);
  const user = useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(userState);

  const { SUCURSAL } = getConfig();

  const sucursales = useRecoilValue(sucursalesState);
  const loadData = useRecoilCallback(
    ({ snapshot }) =>
      async () => {
        const release = snapshot.retain();
        setLoading(true);
        try {
          const sucursalesFetch = snapshot.getPromise(
            sucursalesProcedimientoFetchState,
          );
          const responses = await Promise.all([sucursalesFetch]);

          const servicioFetch =
            await ProcedimientoService.getServicios(SUCURSAL);

          setSucursales(responses[0]);
          setServicio(servicioFetch.data.data);
        } catch (error) {
          catchErrorApi(error);
        } finally {
          setLoading(false);
          release();
        }
      },
    [],
  );

  useEffect(() => {
    loadData();

    return () => {
      loadData();
    };
  }, [loadData]);

  useEffect(() => {
    return () => {
      setIsChangeFormSearch(false);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const myFunction = useRecoilCallback(({ snapshot }) => async (obj) => {

  //     const examenesFetch = snapshot.getPromise(ExamenByTipoExamenState(obj.ptD_RUT));
  //     const responses = await Promise.all([
  //         examenesFetch,
  //     ]);

  //     setExamen(responses[0])

  // }, []);

  return (
    <Grid container spacing={3}>
      {!user.isAuthenticated && (
        <Grid item md={md} xs={12} bottom>
          <InputRut form="procedimiento" styles={{ ...styles }} />
        </Grid>
      )}
      <Grid item md={md} xs={12}>
        {loading ? (
          <AutocompleteSkeleton />
        ) : (
          <AutocompleteSucursalesProcedimiento
            size={size}
            styles={{ ...styles }}
          />
        )}
      </Grid>

      <Grid item md={md} xs={12} bottom>
        {loading ? (
          <AutocompleteSkeleton />
        ) : (
          <AutocompleteServicio size={size} styles={{ ...styles }} />
        )}
      </Grid>

      <Grid item md={md} xs={12}>
        {loading ? (
          <AutocompleteSkeleton />
        ) : (
          <AutocompleteProcedimiento size={size} styles={{ ...styles }} />
        )}
      </Grid>

      {/*<Grid item md={md} xs={12}>
              {loading ? <AutocompleteSkeleton /> : <AutocompletePrevision size={size} styles={{ ...styles }} />}
          </Grid>*/}

      {buttonSearch && (
        <Grid
          display={"flex"}
          justifyContent="center"
          alignItems={"center"}
          item
          md={md}
          xs={12}
        >
          {buttonSearch}
        </Grid>
      )}
    </Grid>
  );
};

export default FormSearchProcedimiento;
